import { Icon, type IconName } from '@/components/Icon';
import type { ChannelKind, NotificationChannel } from '@/types/sturm';

const KIND_ICON: Record<ChannelKind, IconName> = {
  chat: 'hash',
  email: 'mail',
  pager: 'bell',
  webhook: 'link',
};

interface ChannelChipProps {
  channel: NotificationChannel | undefined;
  on?: boolean;
  onClick?: () => void;
}

export function ChannelChip({ channel, on, onClick }: ChannelChipProps) {
  if (!channel) {
    return null;
  }

  return (
    <span
      className={`chan ${onClick ? 'is-pick' : ''} ${on ? 'is-on' : ''}`}
      onClick={onClick}
      title={channel.isConfigured ? undefined : 'This channel has no target configured yet.'}
    >
      <Icon name={KIND_ICON[channel.kind]} size={12} />
      {channel.name}
      {channel.isConfigured ? null : <Icon name="alert" size={11} />}
    </span>
  );
}
